import { render, staticRenderFns } from "./PublicSelect.vue?vue&type=template&id=8d50164e&scoped=true&"
import script from "./PublicSelect.vue?vue&type=script&lang=js&"
export * from "./PublicSelect.vue?vue&type=script&lang=js&"
import style0 from "./PublicSelect.vue?vue&type=style&index=0&id=8d50164e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d50164e",
  null
  
)

export default component.exports